var plugin_rtlignore_default = {
  "alignLeft": "KXyCx",
  "textWrapNowrap": "eVd8E",
  "alignRight": "hx9Xe",
  "alignCenter": "ySPCD",
  "sizeFullWidth": "fDqpi",
  "renderedInTable": "fOX1a",
  "sizeOriginal": "t8tim",
  "sizeContent": "gAqqn",
  "sizeSmall": "q-Sjw",
  "sizeSmallCenter": "_95k42",
  "flex": "Z8VFB",
  "atomic": "IgkLF",
  "anchor": "eJR-H",
  "embed": "_7PQUo",
  "horizontalScrollbar": "gYCdl",
  "pluginContainerMobile": "ZwuP3"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
